<h2 mat-dialog-title>{{ data.title ?? '-' }}</h2>
<mat-dialog-content class="mat-typography">
<page-alert [message]="messageSuccess" *ngIf="showSuccessMessage" alertClass="alert-success"></page-alert>
<page-alert [message]="messageError" *ngIf="showErrorMessage" alertClass="alert-danger"></page-alert>
  <mat-tab-group>
    <mat-tab label="Especialidades">
      <h4>{{ getSpecialtysSectionTitle(data.param.type) }}</h4>
      <mat-card *ngFor="let specialty of specialtys">
        <div>{{ specialty.display }}</div>
        <button class="float-right" [disabled]="affiliationStatus == 'cancelled'" mat-flat-button color="warn" (click)="cancelAffiliation(specialty)">
          Remover Vínculo
        </button>
      </mat-card>
    </mat-tab>

    <mat-tab label="Informações Gerais">
      <div class="info">
        <div class="row">
       
          <div class="col-md-5 col-lg-3">Telefone Referêncial:</div>
          <div class="col-md-7 col-lg-9">{{ location?.phone ?? '-' }}</div>
        </div>
        <div class="row">
          <div class="col-md-5 col-lg-3">E-mail:</div>
          <div class="col-md-7 col-lg-9">{{ location?.email ?? '-' }}</div>
        </div>
      </div>
      <mat-dialog-content class="mat-typography">
        <page-map-view [latLong]="data.param.latLong" [address]="location?.address"></page-map-view>
      </mat-dialog-content>
    </mat-tab>

    <mat-tab label="Procedimentos">
      <p>Aqui você pode cadastrar seu próprio tempo de duração médio de um procedimento:</p>
      <div class="specialty-cards">
        <div *ngFor="let specialty of specialtys; let i = index">
          <form [formGroup]="specialtyForms[i]">
            <div>
              <page-title title="Procedimento referente - {{ specialty.display }}"></page-title>
              <div class="col-xs-12">
                <mat-card >
                  <div>{{ specialty.display }}</div>
                    <button mat-flat-button class="float-right" color="primary" [disabled]="affiliationStatus == 'cancelled'" (click)="openChangeHoursDialog(specialty)">
                      Definir Horário
                    </button>
  
                </mat-card>
                <mat-form-field *ngIf="affiliationStatus != 'cancelled'" appearance="outline">
                  <mat-label>Tempo médio de realização (em minutos)</mat-label>
                  <input
                    type="text"
                    matInput
                    placeholder="Tempo médio"
                    formControlName="averageDuration"
                    required
                    (keypress)="allowOnlyNumbers($event)"
                    (paste)="onPasteName($event)"
                  />
                  <mat-error *ngIf="specialtyForms[i].get('averageDuration')?.hasError('required')"> O tempo é obrigatório </mat-error>
                </mat-form-field>
              </div>
              <div class="col-xs-12 col-md-2">
                <mat-checkbox *ngIf="affiliationStatus != 'cancelled'" formControlName="byOrder">
                   Ordem de chegada?
                </mat-checkbox>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="actions">
        <button mat-flat-button color="primary" (click)="saveAverageTime()" [disabled]="isSaving">
          <ng-container *ngIf="!isSaving && affiliationStatus != 'cancelled'">Salvar</ng-container>
          <ng-container *ngIf="isSaving">
            <mat-progress-spinner mode="indeterminate" diameter="20" strokeWidth="3"></mat-progress-spinner>
          </ng-container>
        </button>
      </div>
    </mat-tab>

    <mat-tab label="Pendências" *ngIf="affiliationStatus != 'cancelled'" style="margin-bottom: 2rem">
      <request-hours-changes *ngIf="refreshComponent" [affiliation]="affiliations"></request-hours-changes>
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button color="primary" [mat-dialog-close]="false">Fechar</button>
</mat-dialog-actions>
